import React, { useMemo, useRef } from 'react';
import { Flex, List, type ListRef, useScreenSize } from '@banhala/ui-kit';
import { AtomicRenderer } from 'shared/src/component';
import { useGoodsDetailAtomics } from '../queries/useGoodsDetailAtomics';
import type { IScreensComponent } from 'shared/src/api';
import { isNil } from 'shared/src/utils';
import { useIsSectionVisible } from '../../../../../store/sectionVisibility';

const ProxySkeleton = () => {
  const { width: screenWidth } = useScreenSize();

  const cardWidth = useMemo(() => {
    return (screenWidth - 2) / 3;
  }, [screenWidth]);

  return (
    <Flex>
      <Flex.Row
        padding={{ horizontal: 16, vertical: 16 }}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Flex
          backgroundColor={'bg_tertiary'}
          width={98}
          height={24}
          borderRadius={4}
        ></Flex>
        <Flex
          backgroundColor={'bg_tertiary'}
          width={64}
          height={18}
          borderRadius={4}
        ></Flex>
      </Flex.Row>
      <Flex>
        <List<number>
          data={Array.from({ length: 9 }, (_, index) => index)}
          numColumns={3}
          columnWrapperStyle={{ gap: 2 }}
          renderItem={({ item }) => {
            return (
              <Flex flex={1} position={'relative'} key={item}>
                <Flex
                  width={cardWidth}
                  height={cardWidth * 1.2}
                  backgroundColor={'bg_tertiary'}
                />
                <Flex margin={{ top: 4, bottom: 20 }} gap={2}>
                  <Flex
                    width={cardWidth * 0.8}
                    height={20}
                    backgroundColor={'bg_tertiary'}
                  />
                  <Flex
                    width={cardWidth * 0.9}
                    height={16}
                    backgroundColor={'bg_tertiary'}
                  />
                  <Flex
                    width={cardWidth * 0.4}
                    height={14}
                    margin={{ top: 4 }}
                    backgroundColor={'bg_tertiary'}
                  />
                </Flex>
              </Flex>
            );
          }}
        />
      </Flex>
    </Flex>
  );
};

export const GoodsAtomicRenderer: React.FC<{
  focused: boolean;
  screen: string;
  onChangeHeight: (height: number) => void;
}> = props => {
  const isVisible = useIsSectionVisible('atomic');

  const { data: atomic, isLoading, refetch } = useGoodsDetailAtomics(isVisible);

  const ref = useRef<ListRef<IScreensComponent>>(null);

  if (isNil(atomic)) {
    if (!props.focused) return null;

    return <ProxySkeleton />;
  }

  return (
    <Flex
      onLayout={({ nativeEvent }) => {
        props.onChangeHeight(nativeEvent.layout.height);
      }}
    >
      <AtomicRenderer
        logDisabled={!props.focused}
        listRef={ref}
        hideScrollToTop={true}
        data={atomic}
        fetchNextPage={() => {}}
        scrollToFilterList={() => {}}
        isFetching={isLoading}
        refetch={refetch}
        screen={props.screen}
      />
    </Flex>
  );
};
